// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yhvnq","toggle":"styles_toggle__GIxAZ","preview":"styles_preview__wSqc4"};